import { render } from "./pallet.vue?vue&type=template&id=14d414dc&lang=pug"
import script from "./pallet.vue?vue&type=script&lang=js"
export * from "./pallet.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QDialog,QCard,QCardSection,QCardActions});
